import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoaderService {
  isPageLoading$ = new BehaviorSubject(true);

  constructor() { }
}
